import {
  Flex,
  FlexItem,
  Spinner,
  TextContent,
  TextList,
  TextListItem,
  TextListItemVariants,
  TextListVariants,
  Title,
} from '@patternfly/react-core'
import { CheckIcon, ErrorCircleOIcon } from '@patternfly/react-icons'
import * as React from 'react'

import VisitDateTime from '@app/domain/visit/components/visit-date.component'
import VisitStatus from '@app/domain/visit/components/visit-status.component'
import type { IVisit} from '@app/domain/visit/visit.interface';
import { VisitStatusId } from '@app/domain/visit/visit.interface'
import * as Visits from '@app/state/visits'
import { SmallButton } from '@app/utils/styles/small-button'

interface Props {
  isVisitUpdated: boolean
  setEditable?: () => void
  updateStatus?: Visits.VisitActionStatusId
  visit: IVisit
}

export const ReadOnlyVisitSummaryCard = ({
  isVisitUpdated,
  setEditable,
  updateStatus,
  visit,
}: Props) => {
  const renderStatus = () => {
    if (isVisitUpdated) {
      if (updateStatus === Visits.VisitActionStatusId.Pending) {
        return (
          <div>
            <Spinner size="sm" />
          </div>
        )
      } else if (updateStatus === Visits.VisitActionStatusId.Succeeded) {
        return (
          <div>
            <CheckIcon size="sm" color="green" /> Visit updated successfully
          </div>
        )
      } else if (updateStatus === Visits.VisitActionStatusId.Failed) {
        return (
          <div>
            <ErrorCircleOIcon size="sm" color="red" /> Visit update failed
          </div>
        )
      } else {
        return <div />
      }
    } else {
      return <div />
    }
  }

  return (
    <Flex direction={{ default: 'column' }}>
      <FlexItem>
        <Flex direction={{ default: 'row' }}>
          <FlexItem>
            <Title headingLevel="h2" size="lg">
              Visit Information
            </Title>
          </FlexItem>
          {visit.status === VisitStatusId.Completed ? (
            <></>
          ) : (
            <>
              <FlexItem>
                {setEditable ? (
                  <SmallButton
                    variant="secondary"
                    isDisabled={visit.status === VisitStatusId.InProgress}
                    onClick={setEditable}
                  >
                    Edit
                  </SmallButton>
                ) : null}
              </FlexItem>
              <FlexItem>{renderStatus()}</FlexItem>
            </>
          )}
        </Flex>
      </FlexItem>
      <FlexItem>
        <TextContent>
          <TextList component={TextListVariants.dl}>
            <TextListItem component={TextListItemVariants.dt}>
              Status:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              <VisitStatus status={visit.status} />
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              Date:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              <VisitDateTime dateTime={visit.startTime} />
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              Clinic:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              {visit.location}
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              Type:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              {visit.definition.name}
            </TextListItem>
          </TextList>
        </TextContent>
      </FlexItem>
    </Flex>
  )
}
